import type { Props as TagSelectorOpenerProps } from '../popupOpener/types';
import type { Tag, TagIdExclude } from '../types';

/**
 * Полуичить значение исключения тега tagId
 */
export const genTagIdExcluded = (tagId: Tag['id']): TagIdExclude => {
	return '-' + tagId as TagIdExclude;
};

/**
 * Вернуть чистый tagId без exclude флага
 */
export const genTagIdClear = (tagId: Tag['id'] | TagIdExclude) => {
	if (tagId[0] === '-') return tagId.substring(1) as Tag['id'];

	return tagId as Tag['id'];
};

/**
 * Получить инфомрацию о теге по его id
 */
export const getTagById = (tagId: Tag['id'] | TagIdExclude, tags: TagSelectorOpenerProps['tags']) => {
	tagId = genTagIdClear(tagId);

	const tag = tags.find(tag => tag.id === tagId);
	if (!tag) return;

	return tag;
};
